export const BANKS_TOTAL_COUNT = 5;
export const COUNTRY_CODE = 'US';
